import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import {
  Row,
  Col,
  Button,
  Skeleton,
  DatePicker,
  Form,
} from "antd";
import { NavLink } from "react-router-dom";
import { PrinterOutlined } from "@ant-design/icons";
import LoginChecked from "../Shared/LoginChecked";
import { NumberFormat } from "../Shared/Utility";
import { IdentificationIcon } from "@heroicons/react/24/outline";
import moment from "moment";

function WorkingCapital() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");

  const [loading, setLoading] = useState(false);
  const [FinalData, setFinalData] = useState({});
  const [StartDate, SetStartDate] = useState("2025-06-28"); // default value
  const [EndDate, SetEndDate] = useState(""); // still unused

  useEffect(() => {
    document.title = "Working Capital";
    setLoading(true);

    const data = {
      UserId: UserID,
      AccessKey: AccessKey,
      Dated: StartDate, // keep as per original structure
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Report/GetWorkingCapitalReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then((response) => {
        if (response.data.status_code == 1) {
          setFinalData(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, [StartDate, EndDate]);

  const handleDateChange = (date, dateString) => {
    SetStartDate(dateString);
  };

  const disabledDate = (current) => current && current > moment().endOf("day");

  const {
    totalReceiveable = 0,
    totalStockValue = 0,
    totalCashAtBank = 0,
    totalCashInHand = 0,
    totalPayable = 0,
  } = FinalData;

  const totalInvestment =
    totalReceiveable + totalStockValue + totalCashAtBank + totalCashInHand;
  const netInvestment = totalInvestment - totalPayable;
  const workingCapitalMetrics = [
    {
      title: "Cash Receivable",
      source: "From Cash Receivable report",
      value: totalReceiveable,
    },
    {
      title: "Stock in Hand",
      source: "From Stock detail",
      value: totalStockValue,
    },
    {
      title: "Bank Balance",
      source: "From Cash at Bank in Dashboard",
      value: totalCashAtBank,
    },
    {
      title: "Cash in Hand",
      source: "From Cash in Hand in Dashboard",
      value: totalCashInHand,
    },
    {
      title: "Cash Payable",
      source: "From Cash Payable report",
      value: totalPayable,
      isPayable: true,
    },
  ];

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">Working Capital</h3>
            <div className="header-actions">
              <NavLink to={`/summary-report/print-working-capital?date=${StartDate}`} target="_blank">
                <Button
                  type="dashed"
                  shape="round"
                  size="large"
                  icon={<PrinterOutlined />}
                >
                  Print Report
                </Button>
              </NavLink>
            </div>
          </div>

          <div className="filter-wrap">
            <Form>
              <Form.Item>
                <DatePicker
                  defaultValue={moment(StartDate)}
                  onChange={handleDateChange}
                  disabledDate={disabledDate}
                  allowClear
                />
              </Form.Item>
            </Form>
          </div>

          {loading ? (
            <Row>
              <Col xs={24} md={16}>
                <Skeleton active />
                <Skeleton active />
              </Col>
            </Row>
          ) : (
            <Row justify="center">
              <Col md={20} sm={24}>
                <div className="fb-card">
                  <div className="fb-card-header">
                    <div className="fb-card-title">
                      <span>
                        <IdentificationIcon />
                      </span>
                      <h4>Working Capital Details</h4>
                    </div>
                  </div>

                  <div className="fb-card-body table">
                    <div className="working-capital-grid">
                      {workingCapitalMetrics.map((metric) => (
                        <div
                          key={metric.title}
                          className={`working-capital-metric ${
                            metric.isPayable ? "is-payable" : ""
                          }`}
                        >
                          <div className="metric-head">
                            <h5>{metric.title}</h5>
                            <span>{metric.source}</span>
                          </div>
                          <p>Rs. {NumberFormat(metric.value, 0)}</p>
                        </div>
                      ))}
                    </div>

                    <div className="working-capital-summary">
                      <div className="summary-item">
                        <h5>Total Investment</h5>
                        <p className={totalInvestment >= 0 ? "profit" : "loss"}>
                          Rs. {NumberFormat(totalInvestment, 0)}
                        </p>
                      </div>
                      <div className="summary-item">
                        <h5>Net Investment</h5>
                        <p className={netInvestment >= 0 ? "profit" : "loss"}>
                          Rs. {NumberFormat(netInvestment, 0)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </>
  );
}

export default WorkingCapital;
